import { StaticImage } from 'gatsby-plugin-image';
import type { FC } from 'react';
import { SwiperSlide } from 'swiper/react';

import { AddOnsTemplate } from '@/components/add-ons/template';
import { GalleriesItem } from '@/components/galleries/item';
import { GalleriesList } from '@/components/galleries/list';
import { ComponentsHead } from '@/components/head';
import { AnchorWithTitle } from '@/components/links/anchor';
import { LinkWithTitle } from '@/components/links';
import {
  h3,
  h4,
} from '@/styles/components/titles.module.scss';

export const FOURTH_OF_JULY_TITLE = 'Fourth of July';

export const Head = () => {
  return (
    <ComponentsHead
      title="Tampa 4th of July Boat Cruise | Fireworks on the Bay"
      description="The best seats for fireworks are on the water. Celebrate America’s birthday with a private boat charter and panoramic bay views of the Tampa skyline."
      keywords="4th of July, Fireworks Cruise, Tampa Bay, Independence Day"
    />
  );
};

const SpecialEventsFourthOfJuly: FC = () => {
  return (
    <AddOnsTemplate
      title="4th of July Fireworks Boat Charter – Celebrate on the Water"
      subtitle="4th of July Fireworks Boat Charter – Celebrate on the Water"
    >
      <GalleriesList>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${FOURTH_OF_JULY_TITLE}`}
              src="../../images/special-events/fourth-of-july/dancing-bennington-deck-boat-party.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${FOURTH_OF_JULY_TITLE} slide 1`}
              src="../../images/special-events/fourth-of-july/exiting-stern-beer-can-island-high-tide-party.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
        <SwiperSlide>
          <GalleriesItem>
            <StaticImage
              alt={`${FOURTH_OF_JULY_TITLE} slide 2`}
              src="../../images/special-events/fourth-of-july/models-taking-shots-tampa-bay-boating-adventures.jpg"
            />
          </GalleriesItem>
        </SwiperSlide>
      </GalleriesList>
      <h3  className={h3}>
        Celebrate Independence Day with the Best View in
        Tampa
      </h3>
      <p>
        The{' '}
        <AnchorWithTitle href="https://thetampariverwalk.com/events/fourth-of-july-boat-parade.html">
          Fourth of July{' '}
        </AnchorWithTitle>{' '}
        is one of America’s most beloved holidays—a day to
        honor freedom, bring together loved ones, and
        celebrate our great nation’s history. In{' '}
        <LinkWithTitle to="/areas/">
          Tampa Bay
        </LinkWithTitle>
        , it’s a spectacular occasion filled with live
        music, food festivals, and dazzling fireworks over
        the water. As the sun sets, the skies come alive
        with color, and the bay reflects the fireworks in a
        truly special way.
      </p>
      <p>
        Celebrate Independence Day aboard a private charter
        with front-row access to Tampa’s Fourth of July
        festivities. The annual fireworks display over the
        bay is one of the city’s most anticipated events,
        and there’s no better place to watch than from the
        water.
      </p>
      <p>
        Our{' '}
        <LinkWithTitle to="/services/4-hour-private-party-boat-charter/">
          4-hour charters
        </LinkWithTitle>{' '}
        , departing from the Davis Island Boat Ramp, provide
        an exclusive experience as you cruise through Tampa
        Bay, soaking in sights of the city skyline,
        waterfront homes, and fireworks lighting up the sky.
      </p>
      <h4  className={h4}>
        Choose Tampa Bay Adventures to Cruise in Style
      </h4>
      <p>
        <LinkWithTitle to="/our-boat/">
          The TBBA Adventure I (12 guests) or Paradiso (30
          guests){' '}
        </LinkWithTitle>
        will provide you with a USCG-certified captain and
        shaded seating and coolers with ice and water and
        Bluetooth speakers for music and optional food
        platters and beverage coolers and festive decor. The
        route follows our classic charter path through
        downtown and the bay, offering flexibility and
        comfort as you enjoy the festivities.
      </p>
      <p>
        It is always best to plan ahead and book your
        preferred time slot as this holiday is always in
        high demand. You can experience the energy and
        excitement of Independence Day like never before
        from the comfort of your private charter with the
        sparkling fireworks and open water as your backdrop.
      </p>
    </AddOnsTemplate>
  );
};

export default SpecialEventsFourthOfJuly;
